<template>
  <div id="vehicle-insert-data">
    <basic-insert-data
      masterName="車両"
      :inputTypes="inputTypes"
      backTo="addon-port-master-vehicle-master"
      @insertData="insertData"
      ref="basicInsertData"
    >
    </basic-insert-data>
  </div>
</template>

<script>

import BasicInsertData from "../components/BasicInsertData";
import { snakeCase } from "snake-case";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    BasicInsertData
  },
  data() {
    return {
      inputTypes: [
        {
          label: "名称",
          inputType: "string",
          key: "name",
          regex: /.+/,
        },
        {
          label: "略称",
          inputType: "string",
          key: "short_name",
        },
        {
          label: "備考",
          inputType: "textArea",
          key: "description",
        },
      ],
    }
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
    }),
  },
  methods: {
    ...mapActions(["insertVehicle"]),
    async insertData(value) {
      let name = value[value.findIndex(element => element.key == "name")].value
      let shortName = value[value.findIndex(element => element.key == "short_name")].value
      let description = value[value.findIndex(element => element.key == "description")].value
      let payload = {
        portId: this.selectedPort.id,
        body: {
          keyboard_shortcut: "1", // TODO: 仮の値
          name: name,
          short_name: shortName,
          description: description,
          version: null
        }
      }
      try {
        this.$vs.loading()
        await this.insertVehicle(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            path: "port-master-vehicle-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.inputTypes.findIndex(column => column.key == targetKey)
            let label = this.inputTypes[index].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicInsertData.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicInsertData.openErrorPopup("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
